import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-accessdenied',
    templateUrl: './accessdenied.component.html',
    styleUrls: ['./accessdenied.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessdeniedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
